"use client";

import Button from "@mui/material/Button";
import { useTrackInteraction } from "@/app/hooks/useTrackInteraction";
import { Phone, MessageCircle } from "lucide-react";
import { parsePhoneNumberFromString } from "libphonenumber-js";
interface ContactButtonsProps {
  perfilId: string;
  perfilPhone: string;
  perfilName: string;
  slug: string 
}
export default function ContactButtons({
  perfilId,
  perfilPhone,
  perfilName,
  slug
}: ContactButtonsProps) {
  const {
    trackInteraction
  } = useTrackInteraction();

  // Clean the phone number by removing spaces, parentheses, and hyphens
  const perfilPhoneClean = perfilPhone.replace(/[\s()-]/g, "");

  // Track phone call clicks
  const handlePhoneClick = () => {
    trackInteraction(perfilId, "phone_call", slug);
  };
  const handleWhatsApp = () => {
    trackInteraction(perfilId, "whatsapp_message", slug);
  };

  // Clean the phone number
  let cleanPhone = perfilPhone.replace(/[^\d]/g, ""); // Keep only digits


  // Encode the message properly
  const message = `Olá ${perfilName}. Eu te vi no *KinksPRO.com* e gostaria de agendar uma sessão.`;
  const encodedMessage = encodeURIComponent(message);

  // Construct the WhatsApp URL
  const url = `https://api.whatsapp.com/send/?phone=${cleanPhone}&text=${encodedMessage}`;
  const isPhoneAvailable = perfilPhone !== "Desativado" && perfilPhone !== "Não disponível";
  if (!isPhoneAvailable) return <Button variant="outlined" size="medium" aria-label="WhatsApp" sx={{
    borderRadius: "10px 0px 10px 0px",
    fontWeight: "bold",
    backgroundColor: "grey.400",
    // Change to grey if unavailable
    color: "grey.700",
    // Change text color
    "&.MuiButton-outlined": {
      borderWidth: "1px 0px 1px 1px",
      borderStyle: "solid",
      px: 1.5,
      borderColor: "grey.500",
      // Change border color
      "&:hover": {
        backgroundColor: isPhoneAvailable ? "lightgreen" : "grey.300",
        // Change hover color
        color: isPhoneAvailable ? "grey.900" : "grey.600" // Change hover text color
      }
    }
  }}>
        {perfilPhone === "Desativado" && "Anúncio desativado"}
        {perfilPhone === "Não disponível" && "Telefone não informado"}
      </Button>;
  return <>
      <Button
    // If the phone is available, set href, otherwise set component to "button"
    href={isPhoneAvailable ? url : undefined} component={isPhoneAvailable ? "a" : "button"} // Change to "button" if phone is unavailable
    target={isPhoneAvailable ? "_blank" : undefined} size="medium" aria-label="WhatsApp" onClick={isPhoneAvailable ? () => handleWhatsApp() : undefined} startIcon={<MessageCircle size={22} />} variant="outlined" sx={{
      borderRadius: "10px 0px 0px 0px",
      fontWeight: "bold",
      backgroundColor: isPhoneAvailable ? "success.main" : "grey.400",
      // Change to grey if unavailable
      color: isPhoneAvailable ? "success.contrastText" : "grey.700",
      // Change text color
      "&.MuiButton-outlined": {
        borderWidth: "1px 0px 1px 1px",
        borderStyle: "solid",
        px: 1.5,
        borderColor: isPhoneAvailable ? "success.main" : "grey.500",
        // Change border color
        "&:hover": {
          backgroundColor: isPhoneAvailable ? "lightgreen" : "grey.300",
          // Change hover color
          color: isPhoneAvailable ? "grey.900" : "grey.600" // Change hover text color
        }
      }
    }}>
        {isPhoneAvailable ? parsePhoneNumberFromString(perfilPhone)?.formatInternational() : perfilPhone}
      </Button>

      {/* Call Button */}
      {isPhoneAvailable && <Button href={encodeURI(`tel:${perfilPhone}`)} onClick={handlePhoneClick} variant="outlined" size="medium" aria-label="Telefone" startIcon={<Phone size={15} />} sx={{
      color: "success.main",
      fontWeight: "light",
      borderRadius: "0px 0px 10px 0px",
      "&.MuiButton-outlined": {
        borderWidth: "1px 1px 1px 0px",
        borderStyle: "solid",
        borderColor: "success.main",
        "&:hover": {
          backgroundColor: "rgba(76, 175, 80, 0.2)"
        }
      }
    }}>
          Ligar
        </Button>}
    </>;
}